import React from "react";
import Project from "../components/Project";
import { Route, Link } from "react-router-dom";
import "../styles/projects.css";

const ProjectsNavigation = _ => (
  <main className="project-list">
    <header>
      <h1>
        Below are some personal projects. See my resume for information about
        other work I've done.
      </h1>
    </header>
    <nav>
      <Link to="/projects/aggbuzz">
        <h1>aggbuzz</h1>
        <h2>Platform for video reactions</h2>
      </Link>
      <Link to="/projects/code-g">
        <h1>Code-G Tool</h1>
        <h2>Tax tool for ACA exemption eligibility</h2>
      </Link>
      <Link to="/projects/learn-a-bit">
        <h1>Learn a Bit</h1>
        <h2>Bit manipulation quiz app</h2>
      </Link>
      <Link to="/projects/mecha">
        <h1>mecha</h1>
        <h2>Curated software conference videos</h2>
      </Link>
      <Link to="/projects/spotify-chat">
        <h1>Spotify Chat App</h1>
        <h2>Replacement app for Spotify direct messaging</h2>
      </Link>
      <Link to="/projects/group-travel">
        <h1>Group Travel App</h1>
        <h2>Itinerary and discussion app for group travel planning</h2>
      </Link>
    </nav>
  </main>
);

const Projects = ({ match, style }) => (
  <main style={{ ...style }}>
    <div className="sub-section projects">
      <Route path={`${match.url}/:project`} component={Project} />
      <Route exact path={match.url} component={ProjectsNavigation} />
    </div>
  </main>
);

export default Projects;



// WEBPACK FOOTER //
// ./src/pages/Projects.js